<template>
  <div class="index">

    <topNav></topNav>

    <div class="top" :style="{'background-image':'url(static/news_top_bg.png)','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}">

      <div class="top" :style="{'background-image':'url('+nameType[curType].bg+')','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}">
        <ul class="about_us_nav">
          <li @click="showNameType(0)" :class="[curType==0?'itemActive':'itemNoActive']">{{nameType[0].name}}</li>
          <li @click="showNameType(1)" :class="[curType==1?'itemActive':'itemNoActive']">{{nameType[1].name}}</li>
        </ul>
      </div>

    </div>

    <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:25px;top:150px;width:68%;text-align:left;" class="brief_1 Impact">Green Supply Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div style="position:absolute;left:25px;top:260px;width:55%;text-align:left;" class="brief_1 Impact" v-if="$store.state.language === 'cn'">中国房地产行业<br />绿色供应链行动</div>

    <pageLocation :currentLocation="nameType[curType].name"></pageLocation>

    <div class="aboutUs" style="width:100%;height:auto;margin:120px auto 0px auto;">
      <!-- aboutUs start -->
      <div v-if="curType!=3">
        <div style="width:80%;margin:0 auto"><img :src="nameType[curType].enTitle" style="width:130px;display:block;margin:0 auto;"></div>
        <div  v-if="$store.state.language === 'cn'" style="width:80%;margin:0 auto"><img :src="nameType[curType].chTitle" style="width:100px;display:block;margin:10px auto auto auto;"></div>
      </div>
      <div v-if="curType==3">
        <div style="width:80%;margin:0 auto"><img :src="nameType[curType].enTitle" style="width:180px;display:block;margin:0 auto;"></div>
        <div  v-if="$store.state.language === 'cn'" style="width:80%;margin:0 auto"><img :src="nameType[curType].chTitle" style="width:150px;display:block;margin:10px auto auto auto;"></div>
      </div>

      <div style="width:80%;margin:20px auto;border-top:1px solid #628838">
        <!--名单列表-->
        <ul class="newsItem" v-for="(nameItem,index) in supplierList.list" :key="index">
          <li style="float:left;margin-top:10px;width:20%;">
            <div style="text-align:center;font-weight:700;font-size:20px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">{{nameItem.createdat.substring(5,10)}}</div>
            <div style="text-align:center;">{{nameItem.createdat.substring(0,4)}}</div>
            <div style="text-align:center;">{{nameItem.authorName}}</div>
          </li>
          <li style="float:left;text-align:left;margin-top:10px;margin-bottom:10px;width:50%;">{{nameItem.articleName}}</li>
          <li @click="showOrHideDetail(nameItem.articleId,$event,nameItem.channelId)" style="float:left;margin-top:10px;border:1px solid #8fa926;border-radius:10px;color:#8fa926;width:20px;height:20px;line-height:20px;font-size:20px;">+</li>
          <div style="width:100%;height:2px;clear:both;"></div>
          <!-- <li v-if="nameItem.catCode!='0000411|000043'" class="detailContent detailContentStyle" :id="nameItem.articleId" style="width:95%;display:none;text-align:left;" v-html="nameItem.content.replaceAll('/uploadfile','http://www.cura.cn/uploadfile')"></li> -->
           <li class="detailContent" :id="nameItem.id" style="width:95%;display:none;text-align:left;">
            <!--应该是附件-->
          </li>
          <li v-if="nameItem.catCode!='0000411|000043'" class="detailContent detailContentStyle" :id="nameItem.articleId" style="width:95%;display:none;text-align:left;" v-html="nameItem.content"></li>
         

        </ul>

      </div>

      <!--aboutUs end-->
    </div>

    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>

  </div>
</template>


<script>
import { articleListByPage, articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import topNav from '@/components/topNav'
import pageLocation from '@/components/pageLocation'
export default {
  name: 'greenEnterpriseCase',
  components: {
    topNav, friendLinkAndFooter, pageLocation
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav: false,
      pages: 1,
      curType: 0,

      nameType: [
        { 'name': '供应商案例', 'articleCode': '', 'catCode': '000042|000043', 'bg': 'static/gyslmd_top_bg.png', 'enTitle': 'static/supply_case_en_title.png', 'chTitle': 'static/supply_case_ch_title.png' },
        { 'name': '房企案例', 'articleCode': '', 'catCode': '000042|000044', 'articleList': [], 'bg': 'static/gyslmd_top_bg.png', 'enTitle': 'static/company_case_en_title.png', 'chTitle': 'static/company_case_ch_title.png' },
      ],

      catCode: '000042|000043',
      supplierList: []
    }
  },
  methods: {


    showNameType(n) {
      this.curType = n;
      this.catCode = this.nameType[n].catCode;
      //查询各名单下的文章列表
      this.articleListByPage(this.nameType[n].catCode);
    },




    showOrHideDetail(articleCode, event,channelId) {
      var that = this;
      if (event.target.innerHTML == '+') {
        // if (that.catCode == '000042|00004311') {
          that.articleDetail(articleCode);

        // }
        document.getElementById(articleCode).setAttribute("style", "display:block;text-align:left;")
        document.getElementById(articleCode+''+channelId).setAttribute("style", "display:block;text-align:left;")
        event.target.innerHTML = '-';
      } else {
        document.getElementById(articleCode+''+channelId).setAttribute("style", "display:none")
        document.getElementById(articleCode).setAttribute("style", "display:none")
        event.target.innerHTML = '+';
      }

    },


    articleDetail(articleCode) {
      const params = {
        articleId: articleCode,
        isEn: this.$store.state.language === 'en' ? 1 : 0
      }
      articleDetail(params).then((res) => {
        // console.log(res);
        let articleFileList = res.data.nodeVoList;
        if (articleFileList) {
          var fileHtml = "";
          for (var i = 0; i < articleFileList.length; i++) {
            // fileHtml += "附件" + (i + 1) + "：<a href='http://www.cura.cn:9999/article/api/download?fileId=" + articleFileList[i].safFid + "' >" + articleFileList[i].safFname + "</a><br/>"
             for(var i=0;i<articleFileList.length;i++){
                 fileHtml+="附件"+(i+1)+"：<a href='http://gsc.see.org.cn/file/file/api/download?nodeId="+articleFileList[i].noteId+"' >"+articleFileList[i].nodeName+"</a><br/>"
            }
          }
          document.getElementById(articleCode+''+res.data.channelId).innerHTML = fileHtml;
        }else{
          document.getElementById(articleCode+''+res.data.channelId).setAttribute("style", "display:none")
          document.getElementById(articleCode).setAttribute("style", "display:none")
        }
        // this.list = [res.data]
        // this.content = 
      })

    },

    articleListByPage(catCode, year) {
      var that = this
      // console.log(this.dateY,' =====____');
      const params = {
        page: that.pages,
        catCode: encodeURIComponent(catCode),
        year: year,
        limit: 99999,
        isEn: this.$store.state.language === 'en' ? 1 : 0
      };
      articleListByPage(params).then(res => {
        let _list = res.data.list;
        for(let k=0;k<_list.length;k++){
          _list[k].id = _list[k].articleId+''+ _list[k].channelId
        }
        res.data.list = _list;
        this.supplierList = res.data;
        if(0 <_list.length){
          this.articleDetail(_list[0].articleId)
        }
      });
    }
  },
  mounted() {
    var that = this;

    that.curType = this.$route.query.mdType;

    //加载新闻
    //this.articleDetail('000000004');
    this.articleListByPage(this.catCode, '')

    setTimeout(() => {

      var o = document.querySelectorAll('.detailContent table');

      if (o) {
        for (var i = 0; i < o.length; i++) {
          o[i].setAttribute("style", "width:100%")
        }
      }

    }, 1000);

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  /deep/ * table {
    width: 100%!important;
  }
.detailContentStyle /deep/ * {

  tbody tr {
    display: flex;
    width: 100%;
    td {
      margin: 2px 0;
      height: auto !important;
    }
    td:nth-child(1) {
      width: 40px !important;
    }
    td:nth-child(2) {
      width: auto !important;
      // word-break: break-all;
    }
  }
}

.brief_1 {
  font-size: 20px;
  font-weight: 900;
  color: #fff;
}
.Impact {
  font-family: Impact, 微软雅黑;
}

.about_us_nav {
  margin: 0px;
  padding: 0px;
  display: flex;
  position: absolute;
  bottom: -20px;
  width: 90%;
  left: 5%;
  box-shadow: #ebebeb 5px 5px 5px 5px;
}
.about_us_nav li {
  margin: 0px;
  padding: 0px;
  width: 25%;
  text-align: center;
  height: 35px;
  line-height: 35px;
  border-right: 1px solid #89a128;
  font-size: 12px;
}

.show {
  display: block;
}
.item {
  width: 100%;
  height: 50px;
  margin: 0px;
  display: block;
}
.itemActive {
  background: #89a128;
  color: #fff;
}
.itemNoActive {
  background: #fff;
  color: #89a128;
}
.hidden {
  display: none;
}
.index {
  margin: 0px;
  padding: 0px;
  width: 100%;
  min-height: 960px;
}

.el-select .el-input__inner {
  text-align: center;
}

.el-input__inner {
  text-align: center;
  background-color: #92ab26 !important;
}

.top {
  position: relative;
  width: 100%;
  height: 600px;
  background-size: auto 100%;
  background-position: 0px 0px;
}

.newsItem {
  border-bottom: 1px solid #628838;
  overflow: hidden;
  margin-top: 10px;
}

.newsItem .facePic {
  width: 100px;
}

.navBox {
  width: 150px;
}
.navBox li {
  height: 30px;
}
.navBox li a {
  color: #fff;
  text-align: right;
  display: block;
  width: 100%;
  text-decoration: none;
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/greenEnterpriseCase/greenEnterpriseCase.vue